import { render, staticRenderFns } from "./telehealth.vue?vue&type=template&id=528f7793&scoped=true&"
import script from "./telehealth.vue?vue&type=script&lang=js&"
export * from "./telehealth.vue?vue&type=script&lang=js&"
import style0 from "./telehealth.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./telehealth.vue?vue&type=style&index=1&id=528f7793&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "528f7793",
  null
  
)

export default component.exports